/* eslint-disable */
<!--
1. 安装 cnpm install --save bpmn-js
2. 安装 cnpm install --save bpmn-js-properties-panel
3. 安装 cnpm install --save camunda-bpmn-moddle
-->
<template>
  <div class="progress-dialog-wrapper">
    <!-- 弹窗模式 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      v-if="isDialog"
      :before-close="handleClose"
      width="80%"
      :fullscreen="isFullscreen"
      custom-class="progress-dialog"
    >
      <div class="dialog-content">
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane label="流程图" name="first"></el-tab-pane>
          <el-tab-pane label="流程意见" name="second"></el-tab-pane>
        </el-tabs>

        <div class="tab-content">
          <!-- 流程图 -->
          <div v-if="activeName === 'first'" class="containers" :style="{ height: '70vh' }">
            <el-button
              type="primary"
              style="z-index: 999"
              @click="handleZoom(1)"
              round
              class="enlarge"
              >放大</el-button
            >
            <el-button
              type="primary"
              style="z-index: 999"
              @click="handleZoom(-1)"
              round
              class="narrow"
              >缩小</el-button
            >
            <el-button
              type="info"
              style="z-index: 999"
              @click="toggleFullscreen"
              round
              class="fullscreen"
              >{{ isFullscreen ? '退出全屏' : '全屏' }}</el-button
            >
            <div
              id="canvas"
              ref="canvas"
              class="canvas"
              v-bind:style="{
                width: 100 + scale * 10 + '%',
                height: 100 + scale * 10 + '%'
              }"
            ></div>
          </div>

          <!-- 流程意见 -->
          <div v-if="activeName === 'second'">
            <opininComponent :attr="flowParams" v-if="showContent"></opininComponent>
          </div>

          <!-- 流程表单 -->
          <div v-if="activeName === 'third' && attr && attr.name">
            <component
              :flowParams="flowParams"
              :businessInfo="businessInfo"
              :is="attr.name"
              v-if="showContent"
            ></component>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 非弹窗模式（原有模式） -->
    <div v-else class="containers" :style="{ height: '80vh' }">
      <el-button type="primary" style="z-index: 999" @click="handleZoom(1)" round class="enlarge"
        >放大</el-button
      >
      <el-button type="primary" style="z-index: 999" @click="handleZoom(-1)" round class="narrow"
        >缩小</el-button
      >
      <div
        id="canvas"
        ref="canvas"
        class="canvas"
        v-bind:style="{
          width: 100 + scale * 10 + '%',
          height: 100 + scale * 10 + '%'
        }"
      ></div>
    </div>
  </div>
</template>
<script>
import { initBpmnXmlStr } from './bpmnConstants';
import { getbpmnXml } from '../tmpl/function';
import BpmnViewer from 'bpmn-js/lib/Viewer';
import { CustomViewer } from './ViewrChange';
// 导入 camunda
import camundaModdleDescriptor from 'camunda-bpmn-moddle/resources/camunda';
// 注册自定义组件
import customComponents from '@/mixins/customComponents';

export default {
  mixins: [customComponents],
  components: {},
  data() {
    return {
      diagramVisible: true,
      lastBpmnXmlStr: null,
      nodeCodes: [], //历史走过的节点
      lines: [], //历史走过的线
      nodeCodes2: [], //当前活动节点

      bpmnViewer: null,
      container: null,
      canvas: null,
      scale: 0,
      timer: null, //hover定时器
      isFull: false,

      // 弹窗相关数据
      dialogVisible: false,
      dialogTitle: '流程进展',
      activeName: 'first',
      flowParams: {},
      businessInfo: {},
      showContent: false,
      isFullscreen: false,
      isDataInitialized: false // 标志是否已经初始化过数据
    };
  },
  props: {
    attr: null,
    // 是否为弹窗模式
    isDialog: {
      type: Boolean,
      default: false
    },
    // 弹窗显隐控制
    visible: {
      type: Boolean,
      default: false
    },
    // 弹窗标题
    title: {
      type: String,
      default: '流程进展'
    }
  },
  computed: {},
  watch: {
    attr: {
      handler(v) {
        this.isDataInitialized = false; // 重置初始化标志
        if (this.isDialog && this.dialogVisible) {
          this.initDialogData();
        } else if (!this.isDialog) {
          this.watchTmplIdHandle();
        }
      },
      immediate: true
    },
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val && this.isDialog && this.attr && this.attr.instanceId) {
          this.$nextTick(() => {
            this.initDialogData();
          });
        }
        // 当弹窗关闭时重置初始化标志
        if (!val) {
          this.isDataInitialized = false;
        }
      },
      immediate: true
    },
    title: {
      handler(val) {
        this.dialogTitle = val;
      },
      immediate: true
    }
  },
  mounted() {
    if (!this.isDialog) {
      const canvas = this.$refs.canvas;
      const panelProp = this.$refs.panelProp;
      //生成流程画板
      //this.bpmnModeler = createBpmnModel(canvas,panelProp);
      this.init();
    }
  },
  methods: {
    // 弹窗相关方法
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },

    handleTabClick(tab) {
      this.activeName = tab.name;
      if (tab.name === 'first' && this.isDialog) {
        this.$nextTick(() => {
          this.initCanvas();
        });
      }
    },

    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },

    // 初始化弹窗数据
    initDialogData() {
      if (!this.attr || !this.attr.instanceId || this.isDataInitialized) {
        return;
      }
      this.isDataInitialized = true;
      this.getFlowParams();
    },

    // 获取流程参数
    getFlowParams() {
      const params = {
        instanceId: this.attr.instanceId
      };
      this.$api.formPost('/api/flow/history/getFlowParam', params).then((res) => {
        if (res.retHead.code == '0000000') {
          this.flowParams = {
            ...this.flowParams,
            ...res.retBody
          };
          this.flowParams.instanceId = this.attr.instanceId;
          this.showContent = true;
          if (this.activeName === 'first') {
            this.$nextTick(() => {
              this.initCanvas();
            });
          }
        }
      });
    },

    // 初始化画布（仅在弹窗模式下使用）
    initCanvas() {
      if (!this.isDialog) return;

      this.$nextTick(() => {
        const canvas = this.$refs.canvas;
        if (canvas && this.attr && this.attr.instanceId) {
          this.init();
          this.watchTmplIdHandle();
        }
      });
    },

    // 获取业务信息
    getBusinessInfo() {
      if (this.attr && this.attr.businesskey) {
        const params = {
          businessKey: this.attr.businesskey
        };
        this.$api
          .formPost('/api/major/query/doGetBusinessInfoByBusinessKey', params)
          .then((res) => {
            if (res.retHead.code == '0000000') {
              this.businessInfo = res.retBody;
            }
          });
      }
    },

    handleZoom(flag) {
      console.log(flag);
      if (flag < 0 && this.scale <= 0) {
        return;
      }
      this.scale += flag;
      this.$nextTick(() => {
        //fit-viewport
        if (this.CustomViewer) {
          this.CustomViewer.get('canvas').zoom(this.scale);
        }
      });
    },

    init(isFull) {
      const canvas = this.$refs.canvas;
      const panel = this.$refs.panel;
      if (this.isBoolean(isFull)) {
        this.isFull = isFull ? false : true;
      } else {
        this.isFull = true;
      }
      console.log(isFull);
      console.log(this.bpmnViewer);
      this.$nextTick(() => {
        if (this.CustomViewer) {
          this.CustomViewer.destroy();
        }
        this.CustomViewer = this.createBpmnModel(canvas, panel);
        console.log(this.CustomViewer);
        this.transformCanvas(this.lastBpmnXmlStr);
      });
    },
    createBpmnModel(canvas, panel) {
      // const TranslateModel = {
      //     translate: ["value", CustomTranslate]
      // };
      return new CustomViewer({
        container: canvas,
        // 添加控制板(右边属性配置栏部分)
        propertiesPanel: {
          parent: panel
        },
        // 左边工具栏和右边属性栏配置, 如果只需要左边工具栏可以不添加如下配置，如果需要右边属性栏则需要
        // 进行如下配置
        additionalModules: [
          // 左边工具栏以及节点
          // 右边的工具栏
          // BpmnPanel,
          // camunda 属性
          // CamundaProperties,
          // 语言翻译
          // TranslateModel,
          // 自定义颜色
          // customModule,
        ],
        moddleExtensions: {
          camunda: camundaModdleDescriptor
        }
      });
    },

    // 将字符串转换成图并渲染
    transformCanvas(bpmnXmlStr) {
      const that = this;
      this.CustomViewer.importXML(bpmnXmlStr, (err) => {
        if (err) {
          console.log('初始化失败:' + err);
        } else {
          console.log('初始化成功....');
          // that.addBpmnListener();
        }
        // 让图能自适应屏幕
        const canvas = that.CustomViewer.get('canvas');
        canvas.zoom('fit-viewport', 'auto');
        if (that.nodeCodes) {
          const colorClass = 'nodeSuccess'; //设置历史走过节点的颜色
          that.setNodeColor(that.nodeCodes, colorClass, canvas);
        }
        if (that.lines) {
          const colorClass = 'lineSuccess'; //设置历史走过线的颜色
          that.setNodeColor(that.lines, colorClass, canvas);
        }

        if (that.nodeCodes2) {
          const colorClass = 'nodeActivity'; //设置当前活动节点的颜色
          that.setNodeColor(that.nodeCodes2, colorClass, canvas);
        }

        // 以下代码为：为节点注册鼠标悬浮事件
        const eventBus = this.CustomViewer.get('eventBus');
        const overlays = this.CustomViewer.get('overlays');
        eventBus.on('element.hover', (e) => {
          overlays.clear();
          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
            if (e.element.businessObject.$type == 'bpmn:UserTask') {
              const params = {
                tmplId: this.attr.instanceId,
                key: e.element.id
              };
              // eslint-disable-next-line max-nested-callbacks
              this.$api.formPost('/api/flow/workFlow/doGetByTaskinstInfo', params).then((res) => {
                if (res.retBody) {
                  console.log(res.retBody);
                  let $overlayHtml = `<div class="tipBox" >`;
                  if (res.retBody.task.names) {
                    $overlayHtml =
                      $overlayHtml +
                      '待办：' +
                      `</br>` +
                      '待办人【' +
                      res.retBody.task.names +
                      '】任务开始时间【' +
                      res.retBody.task.startTime +
                      '】' +
                      `</br>`;
                  }
                  const list = res.retBody.tasked;
                  if (list.length > 0) {
                    // eslint-disable-next-line no-useless-concat
                    $overlayHtml = $overlayHtml + '已办：' + `</br>`;
                    for (let i = 0; i < list.length; i++) {
                      $overlayHtml =
                        $overlayHtml +
                        '处理人【' +
                        list[i].name +
                        '】处理时间【' +
                        list[i].endTime +
                        '】' +
                        `</br>`;
                    }
                  }
                  // const $overlayHtml = `<div class="tipBox" >`+"办理人:"+res.retBody.names+
                  // "任务开始时间:"+ res.retBody.startTime+ "任务处理时间:"+ res.retBody.endTime
                  // +`</div>`
                  overlays.add(e.element.id, {
                    position: {
                      top: e.element.height - 150,
                      left: e.element.width
                    },
                    html: $overlayHtml
                  });
                }
              });
            }
          }, 300);
        });
        eventBus.on('element.click', (e) => {
          if (e.element.businessObject.$type == 'bpmn:CallActivity') {
            const params = {
              rootinstanceid: this.attr.instanceId,
              subflowkey: e.element.businessObject.calledElement
            };
            this.$api
              .formPost('/api/flow/history/getSubInstanceidByFlowkeyAndRootInstanceid', params)
              .then((res) => {
                // eslint-disable-next-line no-constant-condition
                if ((res.retHead.code = '0000000')) {
                  if (res.retBody) {
                    window.open(
                      '/#/progress?tmplId=' + res.retBody + '&procInstId=' + this.attr.instanceId,
                      800,
                      600
                    );
                  }
                }
              });
          }
        });
        eventBus.on('element.out', () => {
          overlays.clear();
        });
        //  注册悬浮事件结束
      });
    },
    // 给已经走过的流程添加颜色
    setNodeColor(nodeCodes, colorClass, canvas) {
      for (let i = 0; i < nodeCodes.length; i++) {
        canvas.addMarker(nodeCodes[i], colorClass);
      }
    },
    // watch tmpId 处理
    watchTmplIdHandle() {
      if (!this.attr || !this.attr.instanceId) {
        return;
      }

      const param = {
        procInstId: this.attr.instanceId
      };
      const that = this;
      getbpmnXml(param).then((res) => {
        if (res.retHead.code == '0000000') {
          if (res.retBody.bpmnXml) {
            that.lastBpmnXmlStr = res.retBody.bpmnXml;
          } else {
            that.lastBpmnXmlStr = initBpmnXmlStr(res.retBody);
          }
          if (res.retBody.highLightedNodes) {
            that.nodeCodes = res.retBody.highLightedNodes;
          }
          if (res.retBody.highLightedFlows) {
            that.lines = res.retBody.highLightedFlows;
          }
          if (res.retBody.highLightedActivitis) {
            that.nodeCodes2 = res.retBody.highLightedActivitis;
          }

          that.transformCanvas(that.lastBpmnXmlStr);
        }
      });
    },

    // 取消操作
    cancelOperat() {
      this.$emit('closeDiagram');
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'bpmn-js/dist/assets/diagram-js.css';
@import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
@import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css';
@import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css';

.progress-dialog-wrapper {
  width: 100%;
  height: 100%;
}

.dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;

  .tab-content {
    flex: 1;
    overflow: auto;
  }
}

.containers {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  position: relative;

  .enlarge {
    position: absolute;
    top: 10px;
    right: 90px;
    z-index: 999;
  }
  .narrow {
    position: absolute;
    top: 10px;
    right: 160px;
    z-index: 999;
  }
  .fullscreen {
    position: absolute;
    top: 10px;
    right: 230px;
    z-index: 999;
  }
}
::v-deep .tipBox {
  width: 500px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  padding: 12px;
  color: rgb(255, 187, 0);
}
.canvas {
  width: 100%;
  height: 100%;
}
//  .panel {
//   position: absolute;
//   right: 0;
//   top: 0;
//   width: 300px;
// }
.buttons {
  position: absolute;
  right: 320px;
  top: 2px;
  & > li {
    display: inline-block;
    margin: 5px;
  }
}

::v-deep .nodeSuccess:not(.djs-connection) .djs-visual > :nth-child(1) {
  stroke: red !important;
  stroke-width: 3px;
  /* elements as success */
}
::v-deep .nodeActivity:not(.djs-connection) .djs-visual > :nth-child(1) {
  stroke: rgb(35, 184, 243) !important;
  stroke-width: 3px;
  /* elements as success */
}
.nodeError:not(.djs-connection) .djs-visual > :nth-child(1) {
  stroke: red !important;
  stroke-width: 3px;
  /* elements as error */
}

::v-deep .lineSuccess:not(.djs-shape) .djs-visual :last-child {
  stroke: red !important;
}

.lineError:not(.djs-shape) .djs-visual :last-child {
  stroke: red !important;
}

//  ::v-deep .djs-palette {
//     display:none;
//   }
//   ::v-deep .panel{
//     display:none;
//   }
//   ::v-deep .djs-hit-all{
//     pointer-events:none;
//     fill:none;
//   }
//   ::v-deep .djs-element > .djs-hit-stroke, .djs-element > .djs-hit-click-stroke{
//     pointer-events:none;
//     fill:none;
//   }
//   ::v-deep .djs-bendpoints{
//     display:none;
//   }

// 弹窗相关样式
::v-deep .progress-dialog {
  .el-dialog__body {
    padding: 20px;
    height: 80vh;

    .dialog-content {
      height: 100%;
    }
  }

  &.is-fullscreen {
    .el-dialog__body {
      height: calc(100vh - 120px);
    }
  }
}

::v-deep .el-tabs__content {
  height: calc(100% - 55px);

  .el-tab-pane {
    height: 100%;
  }
}
</style>
